import {useState, useRef, useEffect, useCallback} from 'react';
import {FormContainer, Layout} from '../../../../../palette/Palette';
import {inject, observer} from 'mobx-react';
import {useHistory} from 'react-router-dom';
import HeaderPage from "../../../../../palette/HeaderPage";
import {useJsApiLoader} from "@react-google-maps/api";
import ExpressMap from "./ExpressMap";
import Text from "../../../../../palette/Text";
import VerticalSpace from "../../../../../palette/VerticalSpace";
import DirectionRoutes from "./DirectionRoutes";
import {Button} from "devextreme-react/button";
import {Animated} from "react-animated-css";
import ChoiceDriver from "./ChoiceDriver";
import Details from "./Details";

const {REACT_APP_GM_KEY} = process.env

const now = new Date();

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

function Express(props) {

    const {DataStore} = props;
    const {
        providerPercentage, tripStartControl, bookingAnticipation, contactNumbers, mainViewport,
        dataPassengers
    } = DataStore

    const [dataCoords, setDataCoords] = useState(null);
    const [routesControl, setRouteControl] = useState({origenCity: null, destinyCity: null});
    const [routesExist, setRouteExist] = useState(true);
    const [valueDate, setValueDate] = useState(now);
    const [showCalendar, setShowCalendar] = useState(null);
    const [getCoordsClient, setGetCoordsClient] = useState(null);
    const [restrict, setRestrict] = useState(false);
    const [viewport, setViewport] = useState(null);
    const [showBackBtn, setShowBackBtn] = useState(true);
    const [showBounds, setShowBounds] = useState(false);
    const [dataExpress, setDataExpress] = useState(null);
    const [clickControl, setClickControl] = useState(true);

    let history = useHistory();
    const isMounted = useMountedState()

    const {isLoaded} = useJsApiLoader({
        googleMapsApiKey: REACT_APP_GM_KEY,
        libraries: ["places"],
        region: 'EC'
    })

    const reservationName = `Reserva express para ${dataPassengers.name} ${dataPassengers.lastName}`

    useEffect(() => {
        setViewport(mainViewport)
        if (isMounted()) {
            setViewport(mainViewport)
        }
    }, [isMounted, mainViewport]);

    const backButton = () => {
        return (
            <Button icon="far fa-arrow-alt-circle-left" text="Volver" width={110}
                    onClick={() => {
                        history.push('/control-panel/passengers-managements')
                    }}
            />
        )
    }

    const GetCoordsClient = () => {
        setShowBounds(true)
        setShowBackBtn(false)
        setShowCalendar(true);
        setGetCoordsClient(dataCoords);
    }

    return (
        <>

            <div className="reservation-container">
                {(viewport && isLoaded) &&
                <div className="map-container">
                    <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={true}>
                        <HeaderPage icon={'fas fa-map-marked-alt'} text={reservationName} load={true}/>
                        <FormContainer>
                            <ExpressMap dataCoords={dataCoords} setGetCoordsClient={setGetCoordsClient}
                                        setDataCoords={setDataCoords} restrict={restrict}
                                        setRestrict={setRestrict} setShowBackBtn={setShowBackBtn}
                                        getCoordsClient={getCoordsClient} DataStore={DataStore}
                                        setShowCalendar={setShowCalendar} showBounds={showBounds}
                                        routesExist={routesExist} routesControl={routesControl}
                                        setShowBounds={setShowBounds} setViewport={setViewport}
                                        viewport={viewport} clickControl={clickControl}/>
                        </FormContainer>
                    </Animated>
                </div>}

                {(viewport && isLoaded) &&
                <div className="data-container">
                    <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={true}>
                        <Layout>
                            <Text hover={false} text={'Direcciones'} size={14} color="#19598D" weight={'700'}/>
                        </Layout>
                        <VerticalSpace space={10}/>

                        <DirectionRoutes setDataCoords={setDataCoords} dataCoords={dataCoords} DataStore={DataStore}
                                         setRouteControl={setRouteControl} routesControl={routesControl}
                                         setShowCalendar={setShowCalendar} setClickControl={setClickControl}/>

                        <VerticalSpace space={7}/>

                        {(routesExist && !restrict && showBackBtn) && backButton()}
                        {(!showBackBtn && !showCalendar) &&
                        <Layout center space row>
                            {backButton()}
                            <Button icon="far fa-check-circle" type="success" text="Aceptar ruta" width={150}
                                    onClick={GetCoordsClient}
                            />
                        </Layout>}
                        {showCalendar &&
                        <Text hover={false} text={'Datos del viaje'} size={14} color="#19598D" weight={'700'}/>}
                        <VerticalSpace space={7}/>
                        {showCalendar &&
                        <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={true}>
                            <ChoiceDriver DataStore={DataStore} setDataExpress={setDataExpress}
                                          dataExpress={dataExpress} setValueDate={setValueDate} valueDate={valueDate}
                                          bookingAnticipation={bookingAnticipation}/>
                        </Animated>
                        }
                    </Animated>
                </div>}
            </div>

            <VerticalSpace space={12}/>
            {dataExpress &&
            <div className="reservation-container">
                <div className="details-container">
                    <Details getCoordsClient={getCoordsClient} DataStore={DataStore} dataExpress={dataExpress}
                             dataPassengers={dataPassengers} contactNumbers={contactNumbers} valueDate={valueDate}
                             providerPercentage={providerPercentage} tripStartControl={tripStartControl}/>
                </div>
                <div/>
            </div>}
        </>
    )

}

export default inject('DataStore')(observer(Express));
